import { render, staticRenderFns } from "./editParkingSpaceApply.vue?vue&type=template&id=05c58dc9"
import script from "./editParkingSpaceApply.vue?vue&type=script&lang=js"
export * from "./editParkingSpaceApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports